module.exports = __webpack_public_path__ + "static/media/camera-flat.cc78ff48.svg";